<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonEditMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'edit'">
            <div class="card">
                <div class="card-body">
                    <em-entity-edit-form ref="emEntityEditForm" :entity="modelName" :$_need_store-entity=true
                                         :$_em-custom-vuex-mixin_entity="entityState"></em-entity-edit-form>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    // Author lidongxu
    // Date 2023-08-17 14:04:13

    import emCommonEditMixin from "@/mixin/em/common/edit";
    import emCustomVuexMixin from "@/mixin/em/customVuex";

    export default {
        name: "emDictTypeEditView",
        mixins: [emCommonEditMixin,emCustomVuexMixin],
        computed:{
            modelName(){
                return this.$_emRouterHelperMixin_entityName
            },
            entityState() {
                const crudState = this.$store.state[this.modelName].crudState;
                if (crudState === 'new') {
                    return 'entity';
                }
                return 'editEntity';
            }
        }
    };
</script>